import { render } from "./VueExcelEditor.vue?vue&type=template&id=f5744138&scoped=true"
import script from "./VueExcelEditor.vue?vue&type=script&lang=js"
export * from "./VueExcelEditor.vue?vue&type=script&lang=js"

import "./VueExcelEditor.vue?vue&type=style&index=0&id=f5744138&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5744138"]])

export default __exports__